import MyRoutesModule from './MyRoutesModule'
export default MyRoutesModule
